// extracted by mini-css-extract-plugin
export var hide = "wistiaVideo-module--hide--bXcX4";
export var overlay = "wistiaVideo-module--overlay--0WTTV";
export var placeholder = "wistiaVideo-module--placeholder--9n0cs";
export var videoContainer = "wistiaVideo-module--videoContainer--7q2gb";
export var videoWrapper = "wistiaVideo-module--videoWrapper--xb9k0";